import { styled } from '@creditas/stylitas'

const Bold = styled.span`
  font-weight: 700;
`

export { Bold }
